"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Body/MessagesTable/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _broadcast = require('shared/enum/broadcast');
var _broadcast3 = require('shared/selectors/broadcast');
var _hooks = require('web/services/hooks');
var _campaignState = require('web/screens/Broadcast/campaignState');
var _useSelection = require('./hooks/useSelection'); var _useSelection2 = _interopRequireDefault(_useSelection);
var _useTemplateColumns = require('./hooks/useTemplateColumns'); var _useTemplateColumns2 = _interopRequireDefault(_useTemplateColumns);
var _useBlockedRecipients = require('./hooks/useBlockedRecipients'); var _useBlockedRecipients2 = _interopRequireDefault(_useBlockedRecipients);

var _RecipientsScreen = require('web/screens/Broadcast/Recipients/RecipientsScreen'); var _RecipientsScreen2 = _interopRequireDefault(_RecipientsScreen);
var _AddRecipientsMenu = require('web/screens/Broadcast/Recipients/AddRecipientsMenu'); var _AddRecipientsMenu2 = _interopRequireDefault(_AddRecipientsMenu);
var _BlockedTable = require('./BlockedTable'); var _BlockedTable2 = _interopRequireDefault(_BlockedTable);
var _TableTopBar = require('./components/TableTopBar'); var _TableTopBar2 = _interopRequireDefault(_TableTopBar);
var _ReviewBar = require('./components/ReviewBar'); var _ReviewBar2 = _interopRequireDefault(_ReviewBar);
var _ProgressBar = require('./ProgressBar'); var _ProgressBar2 = _interopRequireDefault(_ProgressBar);
var _BulkControls = require('./BulkControls'); var _BulkControls2 = _interopRequireDefault(_BulkControls);












// Not yet being messaged, so they can still be removed (or taken off the queue).
const isSelectable = (status) =>
  status === _broadcast.broadcastMsgStatus.NOT_SCHEDULED || status === _broadcast.broadcastMsgStatus.QUEUED

/* M5, P3': the recipients the launch gate would refuse, a page at a time,
 * ready for bulk removal. Selection is the page shown's: select all selects
 * it, and a new page starts with nothing selected. */
const BlockedRecipients = ({
  campaign, campaignKey, onAddExisting, onRemovePatients, onDequeuePatients, onStopReviewing,
}) => {
  const { columns, onMove } = _useTemplateColumns2.default.call(void 0, campaignKey)
  const blocked = _useBlockedRecipients2.default.call(void 0, campaign)
  const {
    selectedRowsList, onSetRowSelection, onSetRowsBatchSelection, onClearAllRowsSelection, selectedRowsMap,
  } = _useSelection2.default.call(void 0, )
  const { rows, page } = blocked
  _react.useEffect.call(void 0, () => { onClearAllRowsSelection() }, [page, onClearAllRowsSelection])

  const statusOf = _react.useMemo.call(void 0, 
    () => new Map(rows.flatMap(r => r.Patient ? [[r.Patient.PatientKey, r.Status] ] : [])),
    [rows],
  )
  const selectableKeys = _react.useMemo.call(void 0, 
    () => [...statusOf].filter(([, s]) => isSelectable(s)).map(([k]) => k),
    [statusOf],
  )
  // Only keys on the page shown: a recipient re-read out of the review drops out.
  const selectedKeys = _react.useMemo.call(void 0, 
    () => selectedRowsList.filter(k => statusOf.has(k)),
    [selectedRowsList, statusOf],
  )
  const selectedStatuses = _react.useMemo.call(void 0, () => selectedKeys.map(k => statusOf.get(k)), [selectedKeys, statusOf])
  const hasSelectedRows = selectedKeys.length > 0
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_TableTopBar2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}
        , _react2.default.createElement('div', { className: "campaign--table--top-bar-main", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}
          ,  hasSelectedRows
            ? (
                _react2.default.createElement(_BulkControls2.default, {
                  campaignKey: campaignKey,
                  selectedPatientKeys: selectedKeys,
                  selectedStatuses: selectedStatuses,
                  onClearAllRowsSelection: onClearAllRowsSelection,
                  onRemovePatients: onRemovePatients,
                  onDequeuePatients: onDequeuePatients, __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
                )
              )
            : _react2.default.createElement(_ReviewBar2.default, { blocked: blocked, onShowAll: onStopReviewing, __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}} )
          
        )
      )
      , _react2.default.createElement(_BlockedTable2.default, {
        orgKey: campaign.OrgKey,
        blocked: blocked,
        selectableKeys: selectableKeys,
        selectedRowsMap: selectedRowsMap,
        onSetRowSelection: onSetRowSelection,
        onSetRowsBatchSelection: onSetRowsBatchSelection,
        areAnyRowsSelected: hasSelectedRows,
        onAddPatients: onAddExisting,
        columns: columns,
        onMoveColumn: onMove, __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
      )
    )
  )
}

/* The campaign page's recipients: the shared recipients screen (Rev 31 v2),
 * with the progress row once sending has started; or, while reviewing what
 * the launch gate refuses, just those recipients. */
const MessagesTable = props => {
  const { campaignKey, onAddExisting, onAddFromCsv, onRemovePatients, onDequeuePatients, isReviewingBlocked = false } = props
  const campaign = _hooks.useAppSelector.call(void 0, state => _broadcast3.selectCampaignByKey.call(void 0, state, campaignKey))
  if (!campaign) return null
  if (isReviewingBlocked) return _react2.default.createElement(BlockedRecipients, { ...props, campaign: campaign, __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}} )
  return (
    _react2.default.createElement(_RecipientsScreen2.default, {
      campaign: campaign,
      progress: _campaignState.hasCampaignStarted.call(void 0, campaign) && _react2.default.createElement(_ProgressBar2.default, { campaignKey: campaignKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}} ),
      onAddFromCsv: onAddFromCsv,
      emptyAction: (
        _react2.default.createElement(_AddRecipientsMenu2.default, {
          label: "Add patients" ,
          campaignKey: campaignKey,
          isDisabled: campaign.Archived,
          onAddExisting: onAddExisting,
          onAddFromCsv: onAddFromCsv, __self: this, __source: {fileName: _jsxFileName, lineNumber: 114}}
        )
      ),
      onRemovePatients: onRemovePatients,
      onDequeuePatients: onDequeuePatients, __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}
    )
  )
}

exports. default = MessagesTable
